import React, { useEffect, useRef, useState } from 'react';
import classes from './SearchWithDropdownSmall.module.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMagnifyingGlass, faFilter, faChevronDown } from '@fortawesome/free-solid-svg-icons';
import useClickOutSide from '../../Hooks/useClickOutSide';
import { faSearchengin } from '@fortawesome/free-brands-svg-icons';

const SearchWithDropdownSmall = ({query,setQuery,searchCriteria,setSearchCriteria,searchRecommendations,handleRecommendationClick,handleSearch}) => {
  const [isDropdownVisible, setIsDropdownVisible] = useState(false);

  const toggleDropdown = () => {
    setIsDropdownVisible(prevState => !prevState);
  };

  const handleInputChange = (e) => {
    setQuery(e.target.value);
};

  const handleKeyPress = (e) => {
    if(e.key === "Enter"){
        handleSearch()
    } else {
      const disallowedCharacters = ["(", "{", "[","]","}",")"];
      if (disallowedCharacters.includes(e.key)) {
        e.preventDefault();
      }
    }
} 

const handleInputPaste = (e) => {
  e.preventDefault();

  const pastedText = e.clipboardData.getData("text").replace(/[\(\)\{\}\[\]]/g, ""); // Remove disallowed characters
  const input = e.target;
  const selectionStart = input.selectionStart;
  const selectionEnd = input.selectionEnd;

  const updatedQuery =
    query.substring(0, selectionStart) + pastedText + query.substring(selectionEnd);

  setQuery(updatedQuery);
};

  const [recommendationClicked,setRecommendationClicked] = useState(false);
  const [focus,setFocus] = useState(false);
  const [blurTimeout, setBlurTimeout] = useState(null);
  
  const handleFocus = () => {
    if (blurTimeout) {
      clearTimeout(blurTimeout); 
    }
    setFocus(true);
  };
  
  const handleBlur = () => {
    const timeout = setTimeout(() => setFocus(false),1000);
    setBlurTimeout(timeout);
  };

    const ref = useRef();
    
    useClickOutSide({myRef:ref,isActive:isDropdownVisible,onClick:() => setIsDropdownVisible(false)})

  return (
    <div className="container">
      <div className={classes.mainContainer}>
        <div className={classes.searchIcon}>
          <FontAwesomeIcon icon={faMagnifyingGlass} onClick={handleSearch} />
          <input
            type="text"
            placeholder="Search Books"
            value={query}
            onChange={handleInputChange}
            onKeyDown={(e) => handleKeyPress(e)}
            onFocus={handleFocus}
            onBlur={handleBlur}
            onPaste={handleInputPaste}
          />
        </div>
        <div className={classes.filter} onClick={toggleDropdown}>
          {/* <FontAwesomeIcon icon={faFilter} /> */}

          <div className={classes.searchFilter}>
            <span>
              {searchCriteria === "all"
                ? "All"
                : searchCriteria === "title"
                ? "Title"
                : searchCriteria === "author"
                ? "Author"
                : searchCriteria === "isbnNo"
                ? "ISBN"
                : searchCriteria === "sku"
                ? "SKU"
                : ""}
            </span>
            <FontAwesomeIcon icon={faChevronDown} />
          </div>
         
          {isDropdownVisible && (
            <div ref={ref} className={classes.dropdownli}>
              <ul>
                <li
                  className={
                    searchCriteria === "all" ? classes.activeCriteria : ""
                  }
                  value="all"
                  onClick={() => setSearchCriteria("all")}
                >
                  All
                </li>
                <li
                  className={
                    searchCriteria === "title" ? classes.activeCriteria : ""
                  }
                  value="title"
                  onClick={() => setSearchCriteria("title")}
                >
                  Book Title
                </li>
                <li
                  className={
                    searchCriteria === "author" ? classes.activeCriteria : ""
                  }
                  value="author"
                  onClick={() => setSearchCriteria("author")}
                >
                  Author
                </li>
                <li
                  className={
                    searchCriteria === "isbnNo" ? classes.activeCriteria : ""
                  }
                  value="isbnNo"
                  onClick={() => setSearchCriteria("isbnNo")}
                >
                  ISBN Number
                </li>
                <li
                  className={
                    searchCriteria === "sku" ? classes.activeCriteria : ""
                  }
                  value="sku"
                  onClick={() => setSearchCriteria("sku")}
                >
                  SKU
                </li>
              </ul>
            </div>
          )}
        </div>
      </div>
      {/* Dropdown with Recommendations */}
      {searchRecommendations?.length > 0 && focus && (
        <div className={classes.dropdown}>
          {searchRecommendations?.slice(0, 10).map((recommendation, index) => (
            <div
              key={index}
              className={classes.dropdownItem}
              onClick={() => handleRecommendationClick(recommendation)}
            >
              <FontAwesomeIcon icon={faSearchengin} />
              {recommendation}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default SearchWithDropdownSmall;
